import React, {useState, useEffect} from 'react';
import {
  FormLabel,
  Input,
  Text,
  Box,
  Checkbox,
  Switch,
  Radio,
  Button,
  FormControl,
  Select,
  Flex,
  RadioGroup,
  InputGroup,
  InputRightElement,
  StyledStepper,
  useNumberInput,
  useColorModeValue,
  Stack,
} from '@chakra-ui/react';
import {Controller} from 'react-hook-form';
/**
 * Form input that will be added to the form submit, can also give an error message if the required prop is passed
 * 
 * To use the this you must pass in register and errors from :
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm(); 

  in the parent form

 * @param {id, name, register, errors, required=false, isPassword=false, isEmail=false, datePicker=false} props 
 * @returns 
 */

const CustomInput = props => {
  const [type, setType] = useState('text');
  useEffect(() => {
    if (props.isPassword) {
      setType('password');
    } else if (props.datePicker) {
      setType('date');
    } else if (props.timePicker) {
      setType('time');
    } else if (props.requireInt) {
      setType('number');
    } else if (props.isEmail) {
      setType('email');
    }
  }, []);

  /*   const {getInputProps, getIncrementButtonProps, getDecrementButtonProps} = useNumberInput({
    step: 1,
    defaultValue: props.defaultValue ?? '',
    min: props.min ?? '',
    max: props.max ?? '',
  });

  const inc = getIncrementButtonProps();
  const dec = getDecrementButtonProps();
  const inp = getInputProps(); */
  return (
    <Box mx={props.mx ?? '1'} w={props.w} px={props.px} py={props.py}>
      <FormLabel htmlFor={props.id} mb="-0.5" ml="1" fontSize="sm">
        {props.name ?? ''}
      </FormLabel>
      <InputGroup>
        <Input
          autoFocus={props.id === 'RecordNumber' ? true : false} // #TODO: This is a hack to get the record number to autofocus.  Need to find a better way
          // {...((props.requireInt || props.type == 'number' || type == 'number') && !props.disabled ? {...inp} : {})}
          disabled={props.disabled}
          id={props.id}
          type={props.type ? props.type : type}
          placeholder={props.name ?? ''}
          defaultValue={props.defaultValue}
          borderColor={props.borderColor ?? 'inherit'}
          _hover={{borderColor: props._hover ?? 'blue.400'}}
          _placeholder={{textAlign: 'left'}}
          border="1px"
          {...(props.defaultValue ? {defaultValue: props.defaultValue} : {})}
          bg={props.bg ? props.bg : props.isReadOnly ? useColorModeValue('gray.100', 'gray.600') : 'inherit'}
          color={props.isReadOnly ? 'gray.400' : 'inherit'}
          isReadOnly={props.isReadOnly}
          min={props.min}
          max={props.max}
          maxLength={props.maxLength}
          textAlign={type == 'number' ? 'right' : 'left'}
          pr="4"
          {...props.register(props.id, {
            defaultValue: props.defaultValue,
            value: props.value,
            // onChange: e => props.onChange(e),
            required: props.required ?? false,
            valueAsNumber: props.requireInt ?? false,
            pattern:
              type === 'email'
                ? {
                    value:
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: 'Please enter a valid email',
                  }
                : null,
          })}
          {...(props.value ? {value: props.value} : {})}
          {...(props.onChange ? {onChange: e => props.onChange(e)} : {})}
          {...(props.onBlur ? {onBlur: e => props.onBlur(e)} : {})}
          {...(props.onKeyDown ? {onKeyDown: e => props.onKeyDown(e)} : {})}

          // value={props.value ?? null}
          // onChange={props.onChange ? e => props.onChange(e) : null}
        />
        {/* {type == 'number' && !props.disabled && (
          <InputRightElement width="10px">
            <Flex flexDirection="column">
              <StyledStepper {...inc}>^</StyledStepper>
              <StyledStepper {...dec}>v</StyledStepper>
            </Flex>
          </InputRightElement>
        )} */}
      </InputGroup>
      {/* errors will return when field validation fails  */}
      {props.errors && props?.errors[props.errorId ?? props.id]?.type === 'required' && (
        <Text color="red.400" fontSize="sm">
          * {props.name} is required
        </Text>
      )}
      {props.errors && props?.errors[props.errorId ?? props.id]?.type === 'pattern' && (
        <Text color="red.400" fontSize="sm">
          * {props?.errors[props.errorId ?? props.id]?.message}
        </Text>
      )}
    </Box>
  );
};

/*
 */

const CustomControlledInput = props => {
  const [type, setType] = useState('text');

  useEffect(() => {
    if (props.isPassword) {
      setType('password');
    } else if (props.datePicker) {
      setType('date');
    } else if (props.requireInt) {
      setType('number');
    } else if (props.isEmail) {
      setType('email');
    }
  }, []);

  return (
    <Box mx="1" w={props.w}>
      <FormLabel htmlFor={props.id} mb="-0.5" ml="1" fontSize="sm">
        {props.name ?? ''}
      </FormLabel>
      <Controller
        control={props.control}
        name={props.id}
        rules={{
          required: props.required ?? false,
          valueAsNumber: props.requireInt ?? false,
          pattern:
            type === 'email'
              ? {
                  value:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: 'Please enter a valid email',
                }
              : {},
        }}
        render={({field}) => {
          return (
            <Input
              {...field}
              name={props.id}
              onChange={e => {
                props.onChange(e);
              }}
              value={props.value}
              disabled={props.disabled}
              type={props.type ? props.type : type}
              placeholder={props.name ?? ''}
              borderColor={props.borderColor ?? 'inherit'}
              _hover={{borderColor: props._hover ?? 'inherit'}}
              border="1px"
              bg={props.bg ? props.bg : props.isReadOnly ? 'gray.100' : 'inherit'}
              color={props.isReadOnly ? 'gray.400' : 'inherit'}
              isReadOnly={props.isReadOnly}
              textAlign={type == 'number' ? 'right' : 'left'}
            />
          );
        }}
      />

      {/* errors will return when field validation fails  */}
      {props?.errors[props.id]?.type === 'required' && (
        <Text color="red.400" fontSize="sm">
          * {props.name} is required
        </Text>
      )}
      {props?.errors[props.id]?.type === 'pattern' && (
        <Text color="red.400" fontSize="sm">
          * {props?.errors[props.id]?.message}
        </Text>
      )}
    </Box>
  );
};

// Needs id (what's created in json), name (what's loaded to screen), and register function from useForm (to know what form to register to)
// '...' is the spread operator that passes all the props given to this component to the CustomInput
const DatePicker = props => {
  return (
    <CustomInput
      {...props}
      id={props.id}
      defaultValue={props.defaultValue}
      borderColor={props.borderColor ?? 'inherit'}
      border="1px"
      min={'1900-01-01'}
      max={'2499-12-31'}
      datePicker
    />
  );
};

const TimePicker = props => {
  return (
    <CustomInput
      {...props}
      id={props.id}
      defaultValue={props.defaultValue}
      borderColor={props.borderColor ?? 'inherit'}
      border="1px"
      min={'1900-01-01'}
      max={'2499-12-31'}
      timePicker
    />
  );
};

// // Needs id (what's created in json), name (what's loaded to screen), and register function from useForm (to know what form to register to)
// const CustomRadio = props => {
//   return (
//     <Radio {...props.register(props.id)} colorScheme={'tertiary'} {...props}>
//       {props.name}
//     </Radio>
//   );
// };

// Must pass a list to render (Each item MUST have a key and a value), control & errors from useForm, id, and optional required/disabled boolean values
const CustomRadioGroup = props => {
  useEffect(() => {
    const using = props.defaultValue ? props.defaultValue.toString() : props.list[0]?.value.toString() ?? '1';
  }, []);
  return (
    <>
      <Controller
        name={props.id}
        control={props.control}
        defaultValue={props.defaultValue ? props.defaultValue.toString() : props.list[0]?.value.toString() ?? '1'}
        render={({field}) => (
          <RadioGroup {...field} disabled={props.disabled ?? false}>
            <Flex flexDirection={props.direction ? props.direction : 'row'} justify={props.justify ? props.justify : 'center'}>
              {props?.list.map((item, idx) => {
                if (!item.visible)
                  return (
                    <Radio
                      {...(props.onChange ? {onChange: e => props.onChange(e)} : {})}
                      value={item.value ? item.value.toString() : '0'}
                      colorScheme={'tertiary'}
                      mx="2"
                      key={idx}
                      isDisabled={props.disabled ?? false}
                    >
                      {item.key}
                    </Radio>
                  );
              })}
            </Flex>
          </RadioGroup>
        )}
        rules={{
          required: {value: props?.required ?? false, message: 'Field required.'},
        }}
      />

      {props.id != null && props.errors != null && props.errors[props.id]?.type === 'required' && (
        <Text ml="6" color="red.400" fontSize="sm">
          *field is required
        </Text>
      )}
    </>
  );
};

// Same as the custom radio group above, but allows for ints as values (since otherwise onchange defaults them to strings)
const CustomIntRadioGroup = ({id, control, errors, list, defaultValue, disabled, required}) => {
  return (
    <>
      <Controller
        name={id}
        control={control}
        defaultValue={defaultValue ? defaultValue : 0}
        render={({field}) => (
          <RadioGroup {...field} id={id} onChange={e => field.onChange(parseInt(e))} disabled={disabled ?? false}>
            {list.map((item, idx) => {
              return (
                <Radio value={item.value} name={id} colorScheme={'tertiary'} mx="2" key={idx} isDisabled={disabled ?? false}>
                  {item.key}
                </Radio>
              );
            })}
          </RadioGroup>
        )}
        rules={{
          required: {value: required ?? false, message: 'Field required.'},
        }}
      />

      {id != null && errors != null && errors[id]?.type === 'required' && (
        <Text ml="6" color="red.400" fontSize="sm">
          *field is required
        </Text>
      )}
    </>
  );
};

// will need to redo this how we did the checkbox with a controller to get rid of console warning.  On the todo list
// Needs id (what's created in json), name (what's loaded to screen), and register function from useForm (to know what form to register to)
const CustomSwitch = props => {
  return (
    <Switch {...props.register(props.id)} colorScheme={'tertiary'} borderColor={props.borderColor ?? 'inherit'} border="1px" {...props}>
      {props.name}
    </Switch>
  );
};

// Needs id (what's created in json), name (what's loaded to screen), value (variable with current value) and register/error function from useForm (to know what form to register to)
const CustomSelect = props => {
  return (
    <Box w={props.w}>
      <Flex mt=".5" flexDirection="column">
        <FormLabel htmlFor={props.id} mb="-2" ml="1" fontSize="sm">
          {props.name}
        </FormLabel>
        <Select
          disabled={props.disabled ?? false}
          mt="1.5"
          mb={props.mb ?? '0'}
          id={props.id}
          // value={props.value}
          colorScheme={'tertiary'}
          color={props.color ?? 'black.500'}
          {...props.register(props.id, {
            required: props.required ?? false,
            minLength: 1,
            value: props.value,
            onChange: props.onChange,
          })}
          {...(props.value ? {value: props.value} : {})}
          {...(props.onChange ? {onChange: props.onChange} : {})}
        >
          {props.children}
        </Select>
      </Flex>
      {props?.errors[props.id] && (
        <Text color="red.400" fontSize="sm">
          * {props.name} is required
        </Text>
      )}
    </Box>
  );
};

// Needs id (what's created in json), name (what's loaded to screen), initial (optional int), Also needs a useForm controller,
// NO REGISTER !!! the chakra checkbox hated register so we had to wrap it in a controller and pass that instead
const CustomCheckbox = props => {
  return (
    <FormControl w={props.w}>
      <Controller
        control={props.control}
        name={props.id}
        defaultValue={props.initial ?? false}
        render={({field}) => (
          <Checkbox
            name={props.id}
            id={props.id}
            colorScheme={'tertiary'}
            {...field}
            {...props}
            bg={props.color ?? 'black.500'}
            defaultChecked={props.initial ?? false}
            onChange={props.onChange ?? (e => field.onChange(e.target.checked))}
            isChecked={props.isChecked ?? field.value}
          >
            {props.names ? props.names : props.name}
          </Checkbox>
        )}
      />
    </FormControl>
  );
};

/*
 * Styled button to submit a form, will take up the width of it's container
 * @param {name} props can take in a name prop for what to show as text, by default will be Submit
 * @returns
 */
const SubmitButton = props => {
  return (
    <Button
      disabled={props.disabled ? props.disabled : false}
      ref={props.ref ? props.ref : null}
      type="submit"
      colorScheme="secondary"
      // w="100%"
      {...props}
    >
      {props.name ? props.name : 'Submit'}
    </Button>
  );
};

/*
 * Styled button for a form, will take up the width of it's container
 * @param {name} props can take in a name prop for what to show as text, by default will be a button
 * @returns
 */
const CustomButton = props => {
  return (
    <Button
      disabled={props.disabled ? props.disabled : false}
      type="button"
      colorScheme="secondary" // w={props.w ?? '100%'}
      {...props}
    >
      {props.name ? props.name : 'Button'}
    </Button>
  );
};

export {
  CustomCheckbox,
  CustomInput,
  CustomControlledInput,
  CustomRadioGroup,
  CustomIntRadioGroup,
  CustomSwitch,
  DatePicker,
  TimePicker,
  SubmitButton,
  CustomButton,
  CustomSelect,
};
